var map = {
	"./Baltic_Main.webp": "./src/assets/Baltic_Main.webp",
	"./Chimera_Main.webp": "./src/assets/Chimera_Main.webp",
	"./Desert_Main.webp": "./src/assets/Desert_Main.webp",
	"./DihorOtok_Main.webp": "./src/assets/DihorOtok_Main.webp",
	"./Erangel_Main.webp": "./src/assets/Erangel_Main.webp",
	"./Heaven_Main.webp": "./src/assets/Heaven_Main.webp",
	"./Kiki_Main.webp": "./src/assets/Kiki_Main.webp",
	"./Neon_Main.webp": "./src/assets/Neon_Main.webp",
	"./Range_Main.webp": "./src/assets/Range_Main.webp",
	"./Savage_Main.webp": "./src/assets/Savage_Main.webp",
	"./Summerland_Main.webp": "./src/assets/Summerland_Main.webp",
	"./Tiger_Main.webp": "./src/assets/Tiger_Main.webp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets recursive ^\\.\\/.*\\.webp$";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.webp$
// module id = ./src/assets recursive ^\.\/.*\.webp$
// module chunks = 0